export enum InteractiveSettingsScreen {
  List,
  Edit,
  Remove
}
